import request from '@/utils/request';

export const download = async (
  url: string,
  filename: string,
  contentType: string = 'application/pdf',
  download = false
) => {
  const res = await request({
    url: url,
    method: 'get',
    timeout: 3_600_000,
    responseType: 'blob',
  });
  var file = new Blob([res.data], { type: 'application/pdf' });
  const fileUrl = window.URL.createObjectURL(file);
  if (download) {
    const link = document.createElement('a');
    link.setAttribute('href', fileUrl);
    link.setAttribute('type', contentType);
    link.setAttribute('download', filename);
    link.click();
    link.remove();
  } else {
    // bypass adblock as per https://stackoverflow.com/questions/51272781/why-do-ad-blockers-block-blobs
    const newWindow = window.open('/')!;
    newWindow.onload = () => {
      newWindow.location = URL.createObjectURL(file) as any;
    };
    // window.open(fileUrl);
  }
};
